import { render } from "./SpecialismMultiSelectModel.vue?vue&type=template&id=62ffb68c&ts=true"
import script from "./SpecialismMultiSelectModel.vue?vue&type=script&lang=ts"
export * from "./SpecialismMultiSelectModel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__